/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Statusrevokeerror3Inputs */

const en_usermanagement_permissions_statusrevokeerror3 = /** @type {(inputs: Usermanagement_Permissions_Statusrevokeerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error revoking role`)
};

/**
* | output |
* | --- |
* | "Error revoking role" |
*
* @param {Usermanagement_Permissions_Statusrevokeerror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_statusrevokeerror3 = /** @type {((inputs?: Usermanagement_Permissions_Statusrevokeerror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Statusrevokeerror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_statusrevokeerror3(inputs)
});
export { usermanagement_permissions_statusrevokeerror3 as "userManagement_permissions_statusRevokeError" }